import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card, Table, Form, Input, Select, Button, Space, Tabs, Tag,
  Typography, message, Divider, DatePicker, Tooltip, Modal, Radio, Upload, Alert, Descriptions
} from 'antd';
import { SearchOutlined, ReloadOutlined, InfoCircleOutlined, InboxOutlined, RightOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

// 发票信息 mock
const INVOICE_INFO = {
  title: '随便', taxNo: '764648492302333', bankName: '南京银行',
  bankAccount: '3364747458596976033', regAddress: '菲尼克思路70号总部基地32栋1001333', regPhone: '1398765678',
};
const RECEIVE_INFO = { name: '小王1', phone: '13987654567', address: '菲尼克思路70号总部基地32栋10011' };

// 开票审核 mock
const mockAuditData = [
  { key: '1', id: '1', enterprise: '深圳瀚洋微科技有限公司', enterpriseId: '540177909180476', applyNo: 'INV20260421001', amount: 12800.00, invoiceTitle: '深圳瀚洋微科技有限公司', invoiceType: '增值税普通发票(电子)', time: '2026-04-21 08:50:08', auditor: '--', status: 'pending', invoiceTime: '--', attachment: '' },
  { key: '2', id: '2', enterprise: '杭州云视智联科技有限公司', enterpriseId: '620188012345678', applyNo: 'INV20260418002', amount: 35600.00, invoiceTitle: '杭州云视智联科技有限公司', invoiceType: '增值税专用发票(电子)', time: '2026-04-18 14:22:31', auditor: 'HM_caiwu', status: 'invoicing', invoiceTime: '--', attachment: '' },
  { key: '3', id: '3', enterprise: '广州智慧安防设备有限公司', enterpriseId: '440112098765432', applyNo: 'INV20260415003', amount: 8900.00, invoiceTitle: '广州智慧安防设备有限公司', invoiceType: '增值税专用发票(纸质)', time: '2026-04-15 09:15:42', auditor: 'HM_caiwu', status: 'reject', rejectReason: '开票金额与充值记录不符，请核实后重新申请', invoiceTime: '--', attachment: '' },
  { key: '4', id: '4', enterprise: '北京中科物联技术有限公司', enterpriseId: '110108567890123', applyNo: 'INV20260410004', amount: 56000.00, invoiceTitle: '北京中科物联技术有限公司', invoiceType: '增值税专用发票(纸质)', time: '2026-04-10 16:38:19', auditor: 'HM_caiwu', status: 'success', invoiceTime: '2026-04-12 10:20:33', attachment: 'invoice_file_001.pdf' },
  { key: '5', id: '5', enterprise: '上海锐视电子科技股份有限公司', enterpriseId: '310115234567890', applyNo: 'INV20260405005', amount: 128500.00, invoiceTitle: '上海锐视电子科技股份有限公司', invoiceType: '增值税专用发票(电子)', time: '2026-04-05 11:05:56', auditor: 'HM_caiwu', status: 'success', invoiceTime: '2026-04-07 09:45:12', attachment: 'invoice_file_002.pdf' },
];

// 收票管理 mock
const mockReceiveData = [
  { key: '1', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '200907804843075840', time: '2026-01-08 17:41:48', amount: 0.96, bizType: '提现', invoiceTitle: '深圳汇云科技有限公司', invoiceType: '增值税专用发票(电子)', sendAddress: '--', status: '待生效', attachment: 'receipt_001.pdf' },
  { key: '2', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '200910077092587520', time: '2026-01-08 19:12:06', amount: 0.96, bizType: '提现', invoiceTitle: '南京鹤梦信息技术有限公司', invoiceType: '增值税专用发票(纸质)', sendAddress: '--', status: '待生效', attachment: 'receipt_002.pdf' },
  { key: '3', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '200910117255564902', time: '2026-01-08 19:13:41', amount: 0.96, bizType: '提现', invoiceTitle: '南京鹤梦信息技术有限公司', invoiceType: '增值税专用发票(电子)', sendAddress: '--', status: '待生效', attachment: 'receipt_003.pdf' },
  { key: '4', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '200950993240300339', time: '2026-01-09 22:17:57', amount: 0.78, bizType: '提现', invoiceTitle: '南京鹤梦信息技术有限公司', invoiceType: '增值税专用发票(纸质)', sendAddress: '--', status: '已生效', attachment: 'receipt_004.pdf' },
  { key: '5', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '475271a7-06e31', time: '2025-06-21 08:50:08', amount: 1000.00, bizType: '提现', invoiceTitle: '南京鹤梦信息技术有限公司', invoiceType: '增值税专用发票(电子)', sendAddress: '--', status: '待生效', attachment: 'e_invoice.pdf' },
  { key: '6', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '475271a7-06e33', time: '2025-05-21 08:50:08', amount: 470.03, bizType: '提现', invoiceTitle: '南京鹤梦信息技术有限公司', invoiceType: '增值税专用发票(纸质)', sendAddress: '--', status: '已生效', attachment: 'paper_photo.jpg' },
  { key: '7', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '475271a7-06e34', time: '2025-04-21 08:50:08', amount: 970.03, bizType: '提现', invoiceTitle: '南京鹤梦信息技术有限公司', invoiceType: '增值税专用发票(纸质)', sendAddress: '--', status: '待生效', attachment: 'paper_photo2.jpg' },
  { key: '8', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '475271a7-06e35', time: '2025-03-21 08:50:08', amount: 880.01, bizType: '提现', invoiceTitle: '南京鹤梦信息技术有限公司', invoiceType: '增值税专用发票(纸质)', sendAddress: '--', status: '已生效', attachment: 'paper_photo3.jpg' },
  { key: '9', enterprise: '鹤梦功能验证企业', enterpriseId: 'n0T17a43Kp', invoiceNo: '475271a7-06e43', time: '2025-02-21 08:50:08', amount: 999.99, bizType: '提现', invoiceTitle: '南京鹤梦信息技术有限公司', invoiceType: '增值税专用发票(电子)', sendAddress: '--', status: '已作废', attachment: 'e_invoice2.pdf' },
];

const InvoiceManage = () => {
  const navigate = useNavigate();
  const [auditForm] = Form.useForm();
  const [invoiceForm] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [receiveSearchForm] = Form.useForm();
  const [activeTab, setActiveTab] = useState('audit');
  const [auditModalVisible, setAuditVisible] = useState(false);
  const [confirmModalVisible, setConfirmVisible] = useState(false);
  const [, setCurrentRecord] = useState(null);
  const [addressVisible, setAddressVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [addressRecord, setAddressRecord] = useState(null);
  const [titleDetailVisible, setTitleDetailVisible] = useState(false);
  const [titleDetailRecord, setTitleDetailRecord] = useState(null);

  const auditColumns = [
    { title: '序号', dataIndex: 'id', width: 60, align: 'center' },
    { title: '申请企业', key: 'enterprise', render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.enterprise}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.enterpriseId}</Text></div>) },
    { title: '申请编号', dataIndex: 'applyNo' },
    { title: '开票金额(CNY)', dataIndex: 'amount', align: 'right', render: (v) => <Text strong>¥ {v.toFixed(2)}</Text> },
    { title: '发票抬头', dataIndex: 'invoiceTitle', render: (v, r) => (
      <div>
        <div style={{ fontWeight: 500 }}>{v || '--'}</div>
        {v && <Button type="link" size="small" style={{ padding: 0, fontSize: 12 }} onClick={() => { setTitleDetailRecord(r); setTitleDetailVisible(true); }}>查看</Button>}
      </div>
    )},
    { title: '发票类型', dataIndex: 'invoiceType' },
    { title: '申请时间', dataIndex: 'time', sorter: true },
    { title: '审核账号', dataIndex: 'auditor' },
    {
      title: '状态', dataIndex: 'status',
      render: (s, r) => {
        if (s === 'pending') return <Text style={{ color: '#8c8c8c' }}>待审核</Text>;
        if (s === 'invoicing') return <Text style={{ color: '#1890ff' }}>开票中</Text>;
        if (s === 'reject') return <Space size={4}><Text type="danger">审核未通过</Text><Tooltip title={r.rejectReason}><InfoCircleOutlined style={{ color: '#ff4d4f', cursor: 'help' }} /></Tooltip></Space>;
        return <Text style={{ color: '#52c41a' }}>已开票</Text>;
      },
    },
    { title: '开票时间', dataIndex: 'invoiceTime' },
    { title: '开票附件', dataIndex: 'attachment', render: (t) => t ? <Button type="link" size="small" onClick={() => message.info('下载文件')}>下载</Button> : '--' },
    {
      title: '操作', key: 'action', width: 120,
      render: (_, r) => (
        <Space split={<Divider type="vertical" />}>
          <Button type="link" size="small" style={{ padding: 0 }}>详情</Button>
          {r.status === 'pending' && <Button type="link" size="small" style={{ padding: 0 }} onClick={() => { setCurrentRecord(r); setAuditVisible(true); }}>审核</Button>}
          {r.status === 'invoicing' && <Button type="link" size="small" style={{ padding: 0, color: '#ff4d4f' }} onClick={() => { setCurrentRecord(r); setConfirmVisible(true); }}>开票</Button>}
        </Space>
      ),
    },
  ];

  const receiveColumns = [
    { title: '序号', key: 'idx', width: 60, align: 'center', render: (_, __, i) => i + 1 },
    { title: '开票企业', key: 'enterprise', render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.enterprise}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.enterpriseId}</Text></div>) },
    { title: '开票时间', dataIndex: 'time', sorter: (a, b) => a.time.localeCompare(b.time) },
    { title: '开票金额(CNY)', dataIndex: 'amount', align: 'right', render: (v) => <Text style={{ color: '#1890ff', fontWeight: 500 }}>¥{v.toFixed(2)}</Text> },
    { title: '业务类型', dataIndex: 'bizType', render: (v, r) => (
      <div>
        <Tag color="blue">{v}</Tag>
        <div><Text type="secondary" style={{ fontSize: 12 }}>{r.invoiceNo}</Text></div>
      </div>
    )},
    { title: '发票抬头', dataIndex: 'invoiceTitle', render: (v, r) => (
      <div>
        <div style={{ fontWeight: 500 }}>{v || '--'}</div>
        {v && <Button type="link" size="small" style={{ padding: 0, fontSize: 12 }} onClick={() => { setTitleDetailRecord(r); setTitleDetailVisible(true); }}>查看</Button>}
      </div>
    )},
    { title: '发票类型', dataIndex: 'invoiceType' },
    {
      title: <Space size={4}>状态<Tooltip title={<div><div>待生效：未审核企业提现申请</div><div>已生效：审核通过企业提现申请</div><div>作废：驳回企业提现申请</div></div>}><InfoCircleOutlined style={{ color: '#8c8c8c' }} /></Tooltip></Space>,
      dataIndex: 'status',
      render: (s) => {
        if (s === '待生效') return <Tag>待生效</Tag>;
        if (s === '已生效') return <Tag color="success">已生效</Tag>;
        return <Tag color="error">已作废</Tag>;
      },
    },
    {
      title: '开票附件', dataIndex: 'attachment',
      render: (t) => t ? <Button type="link" size="small" onClick={() => message.success('下载成功')}>下载</Button> : '-',
    },
  ];

  return (
    <div style={{ padding: 16 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>发票管理</Title></div>

      {/* 顶部提示 */}
      <Alert type="info" showIcon style={{ marginBottom: 16, borderRadius: 8 }} message={
        <div>
          <div>1、用于维护平台面向企业的发票信息及票务相关审核流处理。</div>
          <div>2、平台发票信息及接收方式，<Text style={{ color: '#ff4d4f' }}>非财务干系人请勿随意/高频修改</Text>，以免影响企业开票流程。</div>
          <div>3、开票审核请务必确认发票信息及金额准确性。</div>
        </div>
      } />

      {/* 发票信息 + 接收方式 */}
      <Card bordered={false} style={{ marginBottom: 16, borderRadius: 8 }}>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1, paddingRight: 24 }}>
            <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 12 }}>发票信息</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 8, fontSize: 13, color: '#595959' }}>
              <div><Text type="secondary" style={{ width: 100, display: 'inline-block' }}>发票抬头：</Text>{INVOICE_INFO.title}</div>
              <div><Text type="secondary" style={{ width: 100, display: 'inline-block' }}>纳税人识别号：</Text>{INVOICE_INFO.taxNo}</div>
              <div><Text type="secondary" style={{ width: 100, display: 'inline-block' }}>开户银行名称：</Text>{INVOICE_INFO.bankName}</div>
              <div><Text type="secondary" style={{ width: 100, display: 'inline-block' }}>开户银行账号：</Text>{INVOICE_INFO.bankAccount}</div>
              <div><Text type="secondary" style={{ width: 100, display: 'inline-block' }}>注册场所地址：</Text>{INVOICE_INFO.regAddress}</div>
              <div><Text type="secondary" style={{ width: 100, display: 'inline-block' }}>注册固定电话：</Text>{INVOICE_INFO.regPhone}</div>
            </div>
          </div>
          <Divider type="vertical" style={{ height: 'auto', margin: '0 24px' }} />
          <div style={{ flex: 1, paddingLeft: 24, position: 'relative' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <span style={{ fontWeight: 600, fontSize: 15 }}>接收方式</span>
              <Button type="link" style={{ padding: 0 }} onClick={() => navigate('/cost/invoices/manage')}>去管理 <RightOutlined style={{ fontSize: 11 }} /></Button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 8, fontSize: 13, color: '#595959' }}>
              <div><Text type="secondary" style={{ width: 80, display: 'inline-block' }}>收件人：</Text>{RECEIVE_INFO.name}</div>
              <div><Text type="secondary" style={{ width: 80, display: 'inline-block' }}>联系方式：</Text>{RECEIVE_INFO.phone}</div>
              <div><Text type="secondary" style={{ width: 80, display: 'inline-block' }}>收件地址：</Text>{RECEIVE_INFO.address}</div>
            </div>
          </div>
        </div>
      </Card>

      {/* Tabs: 开票审核 + 收票管理 */}
      <Tabs activeKey={activeTab} onChange={setActiveTab} items={[
        { key: 'audit', label: '开票审核', children: (
          <Card bordered={false} style={{ borderRadius: 8 }}>
            <Form form={searchForm} layout="inline" style={{ marginBottom: 16, gap: '12px 0' }}>
              <Form.Item name="applyNo"><Input placeholder="申请编号" allowClear style={{ width: 180 }} /></Form.Item>
              <Form.Item>
                <Space.Compact>
                  <Form.Item name="entType" initialValue="name" noStyle>
                    <Select style={{ width: 100 }}><Option value="name">企业名称</Option><Option value="id">企业ID</Option></Select>
                  </Form.Item>
                  <Form.Item name="entKeyword" noStyle><Select placeholder="请选择企业" showSearch allowClear optionFilterProp="label" style={{ width: 200 }}><Option value="1">测试xxd</Option></Select></Form.Item>
                </Space.Compact>
              </Form.Item>
              <Form.Item name="status"><Select placeholder="状态" style={{ width: 130 }} allowClear><Option value="pending">待审核</Option><Option value="success">已开票</Option><Option value="reject">已驳回</Option></Select></Form.Item>
              <Form.Item name="timeRange">
                <Space.Compact>
                  <Select defaultValue="apply" style={{ width: 100 }}><Option value="apply">申请时间</Option><Option value="audit">审核时间</Option></Select>
                  <RangePicker style={{ width: 260 }} placeholder={['开始时间', '结束时间']} />
                </Space.Compact>
              </Form.Item>
              <Form.Item><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => searchForm.resetFields()}>重置</Button></Space></Form.Item>
            </Form>
            <Table columns={auditColumns} dataSource={mockAuditData} rowKey="key" scroll={{ x: 'max-content' }} pagination={{ showTotal: (t) => `共 ${t} 条记录`, showSizeChanger: true }} />
          </Card>
        )},
        { key: 'receive', label: '收票管理', children: (
          <Card bordered={false} style={{ borderRadius: 8 }}>
            <Alert type="info" showIcon style={{ marginBottom: 16, borderRadius: 6 }} message="鹤梦云生态平台给企业进行收益结算（提现）时，收款企业给平台的开票记录。" />
            <Form form={receiveSearchForm} layout="inline" style={{ marginBottom: 16, gap: '12px 0' }}>
              <Form.Item name="invoiceNo"><Input placeholder="提现编号" allowClear style={{ width: 180 }} /></Form.Item>
              <Form.Item>
                <Space.Compact>
                  <Form.Item name="entType2" initialValue="name" noStyle>
                    <Select style={{ width: 100 }}><Option value="name">企业名称</Option><Option value="id">企业ID</Option></Select>
                  </Form.Item>
                  <Form.Item name="entKeyword2" noStyle><Select placeholder="请选择企业" showSearch allowClear optionFilterProp="label" style={{ width: 200 }}><Option value="1">鹤梦功能验证企业</Option></Select></Form.Item>
                </Space.Compact>
              </Form.Item>
              <Form.Item name="receiveStatus"><Select placeholder="请选择状态" style={{ width: 130 }} allowClear><Option value="待生效">待生效</Option><Option value="已生效">已生效</Option><Option value="已作废">已作废</Option></Select></Form.Item>
              <Form.Item name="receiveTime">
                <Space.Compact>
                  <Text style={{ lineHeight: '32px', padding: '0 8px', whiteSpace: 'nowrap' }}>开票时间</Text>
                  <RangePicker placeholder={['开始日期', '结束日期']} />
                </Space.Compact>
              </Form.Item>
              <Form.Item><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => receiveSearchForm.resetFields()}>重置</Button></Space></Form.Item>
            </Form>
            <Table columns={receiveColumns} dataSource={mockReceiveData} rowKey="key" scroll={{ x: 'max-content' }} pagination={{ showTotal: (t) => `共 ${t} 条`, showSizeChanger: true, showQuickJumper: true }} />
          </Card>
        )},
      ]} />

      {/* 开票审核弹窗 */}
      <Modal title="开票审核" open={auditModalVisible} onCancel={() => setAuditVisible(false)} onOk={() => { message.success('审核已提交'); setAuditVisible(false); auditForm.resetFields(); }} width={480} destroyOnClose>
        <Form form={auditForm} layout="vertical" style={{ marginTop: 24 }} initialValues={{ status: 'pass' }}>
          <Form.Item name="status" label="开票审核" required>
            <Radio.Group><Radio value="pass">通过</Radio><Radio value="reject">未通过</Radio></Radio.Group>
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(p, c) => p.status !== c.status}>
            {({ getFieldValue }) => getFieldValue('status') === 'reject'
              ? <Form.Item name="reason" label="原因" rules={[{ required: true, message: '请输入未通过原因' }]}><Input.TextArea placeholder="请输入原因" rows={4} maxLength={200} showCount /></Form.Item>
              : <div style={{ padding: '12px 16px', background: '#f5f5f5', borderRadius: 4, marginBottom: 24 }}><Text type="secondary" style={{ fontSize: 13 }}>审核通过后记得确认并上传开票凭证。</Text></div>
            }
          </Form.Item>
        </Form>
      </Modal>

      {/* 确认开票弹窗 */}
      <Modal title="确认开票" open={confirmModalVisible} onCancel={() => setConfirmVisible(false)} onOk={async () => { try { await invoiceForm.validateFields(); message.success('开票凭证已上传'); setConfirmVisible(false); invoiceForm.resetFields(); } catch {} }} width={480} destroyOnClose>
        <Form form={invoiceForm} layout="vertical" style={{ marginTop: 24 }}>
          <Form.Item name="proof" label="开票凭证" required rules={[{ required: true, message: '请上传开票凭证' }]}>
            <Upload.Dragger maxCount={1} beforeUpload={() => false}><p className="ant-upload-drag-icon"><InboxOutlined /></p><p className="ant-upload-text">点击或拖拽文件上传</p></Upload.Dragger>
          </Form.Item>
        </Form>
      </Modal>

      {/* 寄送地址弹窗 */}
      <Modal title="寄送地址" open={addressVisible} onCancel={() => setAddressVisible(false)} footer={null} width={450} centered>
        {addressRecord && (
          <div style={{ padding: '16px 0', display: 'grid', gap: 16 }}>
            <div><Text type="secondary">收件人：</Text> {addressRecord.enterprise}</div>
            <div><Text type="secondary">联系方式：</Text> 86-{RECEIVE_INFO.phone}</div>
            <div><Text type="secondary">收件地址：</Text> {RECEIVE_INFO.address}</div>
          </div>
        )}
      </Modal>

      {/* 发票抬头详情弹窗 */}
      <Modal title="发票抬头详情" open={titleDetailVisible} onCancel={() => setTitleDetailVisible(false)} footer={null} width={520}>
        {titleDetailRecord && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="发票抬头">{titleDetailRecord.invoiceTitle || '--'}</Descriptions.Item>
            <Descriptions.Item label="纳税人识别号">91320115MA1TBX9M2Y</Descriptions.Item>
            <Descriptions.Item label="开户行">中国建设银行股份有限公司南京江宁经济开发区支行</Descriptions.Item>
            <Descriptions.Item label="银行账号">6221883030028121841</Descriptions.Item>
            <Descriptions.Item label="注册地">南京市江宁区菲尼克斯路70号总部基地32栋1001室（江宁开发区）</Descriptions.Item>
            <Descriptions.Item label="联系电话">025-84186339</Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default InvoiceManage;
